<script setup lang="ts">
import type { BulletLegendItemInterface } from '@unovis/ts';
import { omit } from '@unovis/ts';
import { VisCrosshair, VisTooltip } from '@unovis/vue';
import { createApp, type Component } from 'vue';
import { ChartTooltip } from '.';

const props = withDefaults(
  defineProps<{
    formatCurrency?: boolean;
    colors: string[];
    index: string;
    items: BulletLegendItemInterface[];
    customTooltip?: Component;
  }>(),
  {
    colors: () => [],
    items: () => [],
  },
);

// Use weakmap to store reference to each datapoint for Tooltip
const wm = new WeakMap();
function template(d: any) {
  if (wm.has(d)) {
    return wm.get(d);
  } else {
    const indexValue = d[props.index];
    if (indexValue == null) return '';
    const componentDiv = document.createElement('div');
    const omittedData = Object.entries(omit(d, [props.index])).map(([key, value]) => {
      const legendReference = props.items.find((i) => i.name === key);
      return { name: key, ...legendReference, value };
    });
    const TooltipComponent = props.customTooltip ?? ChartTooltip;
    createApp(TooltipComponent, {
      title: indexValue.toString(),
      data: omittedData,
      formatCurrency: props.formatCurrency,
    }).mount(componentDiv);
    wm.set(d, componentDiv.innerHTML);
    return componentDiv.innerHTML;
  }
}

function color(d: unknown, i: number) {
  return props.colors[i] ?? 'transparent';
}
</script>

<template>
  <VisTooltip :horizontal-shift="20" :vertical-shift="20" />
  <VisCrosshair :template="template" :color="color" />
</template>
